<template>
  <label type="file" class="base-input-file">
    <span class="base-input-file__text">
      <slot />
    </span>
    <input
      type="file"
      :accept="
        typeof acceptTypes === 'string' ? acceptTypes : acceptTypes.join(',')
      "
      :multiple="isMultiple"
      class="base-input-file__input"
      @change="$emit('file-changed', $event)"
    />
  </label>
</template>

<script>
  import { images, audio, video, documents } from '../../utils/file_types.js';

  export default {
    name: 'BaseInputFile',
    emits: ['file-changed'],
    props: {
      acceptTypes: {
        type: [String, Array],
        required: true,
        validator: (value) => {
          const FILE_TYPES = [...images, ...audio, ...video, ...documents];

          if (typeof value === 'string') return FILE_TYPES.includes(value);

          const validTypes = value.find((type) => FILE_TYPES.includes(type));

          return !!validTypes;
        },
      },
      captureType: {},
      isMultiple: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .base-input-file {
    display: inline-block;
    width: fit-content;
    margin: 0;

    &__text {
      padding: 0;
      text-decoration: underline;
      font-weight: 700;
      background-color: transparent;
      color: inherit;
      cursor: pointer;
    }
    &__input {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
  }
</style>
